import { oxgCloseModal, oxgCloseModalAnimated, oxgCreateLoadingOverlay, oxgFetchModal, oxgOpenModal, oxgRemoveLoadingOverlay } from "../../modules/modals"
import { oxgLangDeOrEn } from "../../modules/get-lang"

window.oxgCopyBriefing = (oxgId, type) => {
  console.log('copy briefing', oxgId, type)
  oxgCreateLoadingOverlay()
  const jq = jQuery
    jq.ajax({
        url: ajax_obj.ajax_url,
        type: 'POST',
        data: {
          action: 'oxg_copy_briefing',
          data: {
            id: oxgId,
            type: type,
          }
        },
        success: function(response) {
          console.log(response)
          oxgRemoveLoadingOverlay()
          let paramOxgId = oxgId.replace('oxg-', '')
          let msg = oxgLangDeOrEn == 'en' ? 'Your new draft was saved.' : 'Dein neuer Entwurf wurde gespeichert.'
          window.open(window.location.origin + '/drafts?id=' + paramOxgId + '&sb_docked=0&msg=' + msg, '_self')
        },
        error: function(response) {
          console.error(response)
          oxgCloseModal('uatc');
          let errorModal = oxgFetchModal('uatce');
          oxgOpenModal(errorModal, 'compact');
          oxgRemoveLoadingOverlay()
        }
    })
}